<div id="map" leaflet [leafletOptions]="mapOptions" (leafletMapReady)="onMapReady($event)" style="height:500px" (leafletClick)="onMapClick($event)">
    <div *ngIf="marker" [leafletLayer]="marker"></div>
</div>